// CustomToolbar.jsx
import React from "react";

export default function CustomToolbar({ toolbarId = "editor-toolbar" }) {
  return (
    <div id={toolbarId}>
      <span className="ql-formats">
        <select className="ql-header" defaultValue="">
          <option value="1"></option>
          <option value="2"></option>
          <option value="3"></option>
          <option value="4"></option>
          <option value="5"></option>
          <option value="6"></option>
          <option value=""></option>
        </select>
      </span>

      <span className="ql-formats">
        <button className="ql-bold"></button>
        <button className="ql-italic"></button>
        <button className="ql-underline"></button>
        <button className="ql-strike"></button>
      </span>

      <span className="ql-formats">
        <button className="ql-blockquote"></button>
        <button className="ql-link"></button>
      </span>

      <span className="ql-formats">
        <button className="ql-list" value="ordered"></button>
        <button className="ql-list" value="bullet"></button>
      </span>

      <span className="ql-formats">
        <button className="ql-indent" value="-1"></button>
        <button className="ql-indent" value="+1"></button>
      </span>

      <span className="ql-formats">
        <select className="ql-color">
          <option value="#000000"></option>
          <option value="#e8e8e8"></option>
          <option value="#4070b5"></option>
          <option value="#242e3b"></option>
          <option value="#ffffff"></option>
          <option value="color-picker"></option>
        </select>
      </span>

      <span className="ql-formats">
        <select className="ql-font" defaultValue="">
          <option value="BankGothic-Regular">BankGothic</option>
          <option value="PTSans">PTSans</option>
          <option value="Calibri">Calibri</option>
          <option value="Calibri-bold">Calibri-bold</option>
          <option value="Sans-Serif">Sans-Serif</option>
        </select>
      </span>
    </div>
  );
}